/**
 * Predictive search in de header-dialog: suggesties via /search/suggest met
 * Section Rendering (sections/predictive-search.liquid), gedebounced en met
 * AbortController. Zonder JS navigeert het zoek-icoon naar /search.
 */

const dialog = document.getElementById('search-dialog');
const input = dialog?.querySelector('[data-suggest-input]');
const results = dialog?.querySelector('[data-suggest-results]');

let controller = null;
let timer = null;

async function fetchSuggestions(term) {
  controller?.abort();
  controller = new AbortController();
  try {
    const params = new URLSearchParams({
      q: term,
      'resources[type]': 'product',
      'resources[limit]': '6',
      section_id: 'predictive-search',
    });
    const res = await fetch(`/search/suggest?${params}`, { signal: controller.signal });
    if (!res.ok) throw new Error(`Suggest: ${res.status}`);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const inner = doc.querySelector('[data-suggest-inner]');
    if (inner) results.innerHTML = inner.innerHTML;
  } catch (error) {
    if (error.name !== 'AbortError') results.innerHTML = '';
  }
}

if (input && results) {
  input.addEventListener('input', () => {
    clearTimeout(timer);
    const term = input.value.trim();
    if (term.length < 2) {
      controller?.abort();
      results.innerHTML = '';
      return;
    }
    timer = setTimeout(() => fetchSuggestions(term), 250);
  });

  // Bij heropenen met oude term: veld selecteren zodat typen direct vervangt
  dialog.addEventListener('close', () => {
    clearTimeout(timer);
    controller?.abort();
  });
}
